// Resolve o filtro de gestor compartilhado (AuthContext) para uma tela.
//
// O filtro e' global e acompanha o usuario na navegacao, mas nem toda tela
// oferece os mesmos responsaveis: a lista de Fcas so' tem quem tem FCA, a de
// Analytics — FCAs idem, e um gestor nao aparece como opcao para si mesmo.
// Quando o escolhido nao esta' entre as opcoes da tela, ela exibe "todos" —
// sem apagar a selecao global, que continua valendo nas outras telas.
//
// Enquanto `opcoes` esta' vazia a lista ainda nao carregou, entao o filtro e'
// mantido: as telas que consultam por gestor_id ja' saem filtradas, sem piscar
// os dados de todo mundo antes.
export function gestorVisivel(filtroGestor, opcoes) {
  if (!filtroGestor) return ''
  if (!opcoes || opcoes.length === 0) return filtroGestor
  return opcoes.some(g => g.id === filtroGestor) ? filtroGestor : ''
}
